import UpdatePharmacyInfo from "components/UpdatePharmacyInfo";
import SwitchPharmacyInfo from "components/SwitchPharmacyInfo";
import { formatPhoneNumber, prependCountryCodeToPhoneNumber } from "services/UtilityService";
import { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import { getLoggedInUser } from "services/AuthService";
import { isLoggedInUserAWSConnectAgent } from "services/AWUtilityService";
import ConnectCallButton from "components/CallCenterOption/connectCallButton";
import { useSelector } from 'react-redux';
import OverlayBadge from "components/OverlayBadge";
import { FeatureFlagConstants } from "../../lookup/FeatureFlagConstants"
import { useFeatureFlag } from "../../hooks/UseFeatureFlag"

const PharmacyDetails = (props) => {
  const [pharmacy, setPharmacy] = useState(props.pharmacy);
  const { isDisabled, wfItemId, globalSwitchId } = props;
  const callGroupId = useSelector((state) => 
    state?.callGroupDetails?.callGroupData?.callGroupId ?? null
  );
  const activityId = useSelector((state) => state?.callGroupDetails?.activityDetails?.activityId ?? null)
  const clientId = useSelector((state) => 
   state?.switchDetails?.switchData?.switchInfo?.clientInfo?.clientId ?? 
  state?.callGroupDetails?.activityDetails?.wfItem?.switchInfo?.clientInfo?.clientId ?? null);
  const customerId = useSelector((state) => 
  state?.switchDetails?.switchData?.switchInfo?.rirCustomerInfo?.customerId ?? 
  state?.callGroupDetails?.activityDetails?.wfItem?.switchInfo?.rirCustomerInfo?.customerId ?? null);
  const updatePharmacyData = (updatedPharmacy) => {
    setPharmacy(updatedPharmacy);
  };
  const [isFeatureEnabled, _] = useFeatureFlag(FeatureFlagConstants.AWS_CONNECT_ENABLED);
  const isAWSConnectAgentEnable = isLoggedInUserAWSConnectAgent();

  useEffect(() => {
    setPharmacy(props.pharmacy);
  }, [props.pharmacy]);

  return (
    <>
      <div data-testid='text-pharmacy-name'>
        {pharmacy.pharmacyName}
        {!props.isFromAW && (
          <>   
            <OverlayBadge placement="top" className="custom-badge" bg="warning" badgeText={pharmacy.state} hoverText={pharmacy.rescheduleInterval} />
          </>
        )}
        &nbsp;
        {pharmacy.gatekeeper ?
          <Badge bg="warning" pill data-testid='badge-pharmacy-gatekeeper'>
            Gatekeeper
          </Badge>
          :
          <></>
        }
      </div>
      
      {!isDisabled ? (
        <UpdatePharmacyInfo
          pharmacy={pharmacy}
          isDisabled={isDisabled}
          onSubmission={updatePharmacyData}
          updateData={props.updateData}
          wfItemId={wfItemId}
          isFromAW={props.isFromAW}
          activityType={props.activityType}
        />
      ) : null}
      {!isDisabled ? (
        <SwitchPharmacyInfo
          pharmacy={pharmacy}
          isDisabled={isDisabled}
          wfItemId={wfItemId}
          onSubmission={updatePharmacyData}
        />
      ) : null}
      <Row>
        <Col md={8}>
        <div className="rm-tiny-top-label tiny-top-spacer">Phone
        {isAWSConnectAgentEnable && pharmacy?.pharmacyPhone && (<ConnectCallButton body={{ 
          agent: getLoggedInUser()?.email, 
          phone: prependCountryCodeToPhoneNumber(pharmacy?.pharmacyPhone, 1), 
          switchId: globalSwitchId ,entityName:pharmacy.pharmacyName , 
          entityType: 'Pharmacy', 
          callGroupId : callGroupId, 
          activityId: activityId, 
          clientId: clientId, 
          customerId: customerId}} label='Pharmacy'/>)}    
        </div>
        <div data-testid='text-pharmacy-phone'>{formatPhoneNumber(pharmacy.pharmacyPhone)}</div>
        </Col>
        <Col md={4}>
        <div className="rm-tiny-top-label tiny-top-spacer">Time Zone</div>
        <div data-testid='text-pharmacy-timezone'>{pharmacy.timeZone ? pharmacy.timeZone : "N/A"}</div>
        </Col>
      </Row>
      <div className="rm-tiny-top-label tiny-top-spacer">Fax</div>
      <div data-testid='text-pharmacy-fax'>{formatPhoneNumber(pharmacy.pharmacyFax)}</div>
      <div className="rm-tiny-top-label tiny-top-spacer">Npi</div>
      <div data-testid='text-pharmacy-npi'>{pharmacy.pharmacyNpi}</div>
      <div className="rm-tiny-top-label tiny-top-spacer">Address</div>
      <div data-testid='text-pharmacy-address'>{pharmacy.pharmacyAddress ? pharmacy.pharmacyAddress : "N/A"}</div>
    </>
  );
};

export default PharmacyDetails;
